/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from './types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
export type SocialFeedPostAddLikeMutationVariables = Types.Exact<{
  input: Types.SocialPostLikeInput;
}>;


export type SocialFeedPostAddLikeMutation = { __typename?: 'Mutation', socialPostLike: { __typename?: 'SocialPostLikeResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialFeedPostRemoveLikeMutationVariables = Types.Exact<{
  input: Types.SocialPostLikeRemoveInput;
}>;


export type SocialFeedPostRemoveLikeMutation = { __typename?: 'Mutation', socialPostLikeRemove: { __typename?: 'SocialPostLikeRemoveResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialFeedCommentAddLikeMutationVariables = Types.Exact<{
  input: Types.SocialCommentLikeInput;
}>;


export type SocialFeedCommentAddLikeMutation = { __typename?: 'Mutation', socialCommentLike: { __typename?: 'SocialCommentLikeResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialFeedCommentRemoveLikeMutationVariables = Types.Exact<{
  input: Types.SocialCommentLikeRemoveInput;
}>;


export type SocialFeedCommentRemoveLikeMutation = { __typename?: 'Mutation', socialCommentLikeRemove: { __typename?: 'SocialCommentLikeRemoveResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialPostSaveMutationVariables = Types.Exact<{
  input: Types.SocialPostSaveInput;
}>;


export type SocialPostSaveMutation = { __typename?: 'Mutation', socialPostSave: { __typename?: 'SocialPostSaveResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialPostUnsaveMutationVariables = Types.Exact<{
  input: Types.SocialPostSaveRemoveInput;
}>;


export type SocialPostUnsaveMutation = { __typename?: 'Mutation', socialPostSaveRemove: { __typename?: 'SocialPostSaveRemoveResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type SocialListPostByProductQueryVariables = Types.Exact<{
  input: Types.SocialListPostByProductInput;
}>;


export type SocialListPostByProductQuery = { __typename?: 'Query', socialListPostByProduct: { __typename?: 'SocialListPostByProductResponse', Pagination?: { __typename?: 'SocialListPostByProductPagination', nextPageCursor?: number | null, hasNextPage?: boolean | null } | null, Posts: Array<{ __typename?: 'Post', id: string, postSlug?: string | null, likesCount: number, commentsCount: number, user: { __typename?: 'PublicUserProfile', firstName?: string | null, lastName?: string | null, displayName?: string | null, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null } | null }, assets?: Array<{ __typename?: 'SocialAsset', url: string, optimizedUrl?: string | null, type: Types.SocialAssetType }> | null } | null>, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };


export const SocialFeedPostAddLikeDocument = `
mutation socialFeedPostAddLike($input: SocialPostLikeInput!) {
  socialPostLike(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialFeedPostAddLikeMutationKey = 'socialFeedPostAddLike'

export function socialFeedPostAddLikeMutationFetcher(variables: SocialFeedPostAddLikeMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialFeedPostAddLikeMutation, SocialFeedPostAddLikeMutationVariables>(SocialFeedPostAddLikeDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialFeedPostAddLikeMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialFeedPostAddLikeMutation, E, SocialFeedPostAddLikeMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialFeedPostAddLikeMutation, E, SocialFeedPostAddLikeMutationVariables, C>({
        ...options,
        mutationKey: [socialFeedPostAddLikeMutationKey],
        mutationFn: (variables: SocialFeedPostAddLikeMutationVariables) => socialFeedPostAddLikeMutationFetcher(variables, fetchOptions),
    })
}

export const SocialFeedPostRemoveLikeDocument = `
mutation socialFeedPostRemoveLike($input: SocialPostLikeRemoveInput!) {
  socialPostLikeRemove(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialFeedPostRemoveLikeMutationKey = 'socialFeedPostRemoveLike'

export function socialFeedPostRemoveLikeMutationFetcher(variables: SocialFeedPostRemoveLikeMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialFeedPostRemoveLikeMutation, SocialFeedPostRemoveLikeMutationVariables>(SocialFeedPostRemoveLikeDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialFeedPostRemoveLikeMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialFeedPostRemoveLikeMutation, E, SocialFeedPostRemoveLikeMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialFeedPostRemoveLikeMutation, E, SocialFeedPostRemoveLikeMutationVariables, C>({
        ...options,
        mutationKey: [socialFeedPostRemoveLikeMutationKey],
        mutationFn: (variables: SocialFeedPostRemoveLikeMutationVariables) => socialFeedPostRemoveLikeMutationFetcher(variables, fetchOptions),
    })
}

export const SocialFeedCommentAddLikeDocument = `
mutation socialFeedCommentAddLike($input: SocialCommentLikeInput!) {
  socialCommentLike(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialFeedCommentAddLikeMutationKey = 'socialFeedCommentAddLike'

export function socialFeedCommentAddLikeMutationFetcher(variables: SocialFeedCommentAddLikeMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialFeedCommentAddLikeMutation, SocialFeedCommentAddLikeMutationVariables>(SocialFeedCommentAddLikeDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialFeedCommentAddLikeMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialFeedCommentAddLikeMutation, E, SocialFeedCommentAddLikeMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialFeedCommentAddLikeMutation, E, SocialFeedCommentAddLikeMutationVariables, C>({
        ...options,
        mutationKey: [socialFeedCommentAddLikeMutationKey],
        mutationFn: (variables: SocialFeedCommentAddLikeMutationVariables) => socialFeedCommentAddLikeMutationFetcher(variables, fetchOptions),
    })
}

export const SocialFeedCommentRemoveLikeDocument = `
mutation socialFeedCommentRemoveLike($input: SocialCommentLikeRemoveInput!) {
  socialCommentLikeRemove(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialFeedCommentRemoveLikeMutationKey = 'socialFeedCommentRemoveLike'

export function socialFeedCommentRemoveLikeMutationFetcher(variables: SocialFeedCommentRemoveLikeMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialFeedCommentRemoveLikeMutation, SocialFeedCommentRemoveLikeMutationVariables>(SocialFeedCommentRemoveLikeDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialFeedCommentRemoveLikeMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialFeedCommentRemoveLikeMutation, E, SocialFeedCommentRemoveLikeMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialFeedCommentRemoveLikeMutation, E, SocialFeedCommentRemoveLikeMutationVariables, C>({
        ...options,
        mutationKey: [socialFeedCommentRemoveLikeMutationKey],
        mutationFn: (variables: SocialFeedCommentRemoveLikeMutationVariables) => socialFeedCommentRemoveLikeMutationFetcher(variables, fetchOptions),
    })
}

export const SocialPostSaveDocument = `
mutation socialPostSave($input: SocialPostSaveInput!) {
  socialPostSave(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialPostSaveMutationKey = 'socialPostSave'

export function socialPostSaveMutationFetcher(variables: SocialPostSaveMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialPostSaveMutation, SocialPostSaveMutationVariables>(SocialPostSaveDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialPostSaveMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialPostSaveMutation, E, SocialPostSaveMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialPostSaveMutation, E, SocialPostSaveMutationVariables, C>({
        ...options,
        mutationKey: [socialPostSaveMutationKey],
        mutationFn: (variables: SocialPostSaveMutationVariables) => socialPostSaveMutationFetcher(variables, fetchOptions),
    })
}

export const SocialPostUnsaveDocument = `
mutation socialPostUnsave($input: SocialPostSaveRemoveInput!) {
  socialPostSaveRemove(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const socialPostUnsaveMutationKey = 'socialPostUnsave'

export function socialPostUnsaveMutationFetcher(variables: SocialPostUnsaveMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialPostUnsaveMutation, SocialPostUnsaveMutationVariables>(SocialPostUnsaveDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialPostUnsaveMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialPostUnsaveMutation, E, SocialPostUnsaveMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialPostUnsaveMutation, E, SocialPostUnsaveMutationVariables, C>({
        ...options,
        mutationKey: [socialPostUnsaveMutationKey],
        mutationFn: (variables: SocialPostUnsaveMutationVariables) => socialPostUnsaveMutationFetcher(variables, fetchOptions),
    })
}

export const SocialListPostByProductDocument = `
query socialListPostByProduct($input: SocialListPostByProductInput!) {
  socialListPostByProduct(input: $input) {
    Pagination {
      nextPageCursor
      hasNextPage
    }
    Posts {
      id
      user {
        firstName
        lastName
        displayName
        profileUrls {
          crafter
        }
      }
      postSlug
      assets {
        url
        optimizedUrl
        type
      }
      likesCount
      commentsCount
    }
    errors {
      code
      message
    }
  }
}

`

export const socialListPostByProductQueryRootKey = 'socialListPostByProduct'

export function socialListPostByProductQueryFetcher(variables: SocialListPostByProductQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialListPostByProductQuery, SocialListPostByProductQueryVariables>(SocialListPostByProductDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function socialListPostByProductQueryKey(variables: SocialListPostByProductQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [socialListPostByProductQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function socialListPostByProductQueryOptions(
    variables: SocialListPostByProductQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialListPostByProductQuery, unknown, SocialListPostByProductQuery, (SocialListPostByProductQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: socialListPostByProductQueryKey(variables, fetchOptions),
        queryFn: socialListPostByProductQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialListPostByProductQuery<D = SocialListPostByProductQuery, E = unknown>(
    variables: SocialListPostByProductQueryVariables,
    options?: Omit<UseQueryOptions<SocialListPostByProductQuery, E, D, (SocialListPostByProductQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialListPostByProductQuery, E, D, (SocialListPostByProductQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...socialListPostByProductQueryOptions(variables, fetchOptions),
    })
}